import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout"
import { ProfileHeader} from "../components/profile";
import { TitleHeader, ArrowLink, wrapper } from '../components/defaults/styles/elements';
import { color } from '../components/defaults/styles/theme';
import mq from '../components/defaults/styles/mediaquerys';
import { css } from '@emotion/react';
import ProfileUsers from '../components/main/profile-users';
import Star from '../components/defaults/assets/svg/star.svg';
import Award from '../components/defaults/assets/svg/award.svg';
import Play from '../components/defaults/assets/svg/play.svg';
import Rearview from '../components/defaults/assets/svg/rearview.svg';
import Calendar from '../components/defaults/assets/svg/calendar.svg';
import FileText from '../components/defaults/assets/svg/file-text.svg';
import { People } from '../components/defaults/assets/svg/mobilenav';
import ProfileYoutube from '../components/main/profile-youtube';
import GeneralFooter from '../components/general_footer';
import RearviewInline from '../components/main/rearviewInline';
import AgendaEl from '../components/main/agenda-el';
import moment from 'moment';
import Flags from '../data/raw/flags';
import NavigationData from '../data/navigation_data';
import publishFilter from '../components/defaults/filters/publish';
import sortAgenda from '../components/defaults/filters/sortAgenda';
import CaseStudyLink from '../components/main/casestudy-el-link';
import PartnerLogo from '../components/main/logo-partner';


const PartnerCaseStudies = ({data}) => {

  const casestudyElement = css`
    flex: 1 0 100%;
    ${mq[2]} {
      flex: 0 0 calc((100% - (0.75em * 1)) / 2);
    }
  `
  
  return (

    <div css={css`
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 5em;
    `}>
      {publishFilter(data.airtable.data.casestudies, "cs_publish").map(({ data }, index) => (
        <CaseStudyLink 
          data={data}
          key={index} 
          css={css`
            ${casestudyElement}
            margin-bottom: .75em;
          `}
        />
      ))}
      <div css={css`
        ${casestudyElement}
      `} />
    </div>
  )
}


const PartnerTemplate = ({ pageContext, data }) => {
    const { safe_url } = pageContext

    const seo = {
      frontmatter: {
        title: data.airtable.data.name,
      },
    }
    
    let champions = []
    let executives = []
    let attendee = []

    // remove all !not champions/ops from users array
    if (data.airtable.data.users) {
      const el_to_include = ["STARTUP AUTOBAHN Champion", "Organizer"]

      champions = data.airtable.data.users.filter(
        ({ data }) =>
          el_to_include.some(el => data.group.includes(el)) &&
          data.include === true && data.consent === true
      )

      executives = data.airtable.data.users.filter(
        ({ data }) =>
          data.group.includes("Partner Executive Representative") &&
          data.include === true &&
          data.consent === true
      )
      
      attendee = data.airtable.data.users.filter(
        ({ data }) =>
          data.group.includes("Partner Business Unit Employee") &&
          data.include === true &&
          data.consent === true
      )
    }

    let agendaDestination = ''
    NavigationData.main.forEach((e) => {
      if (e.name === "Agenda") {
        agendaDestination = e.url
        return null
      }
    })

    return (
      <Layout dark seo={seo}>
        <ProfileHeader
          data={data.airtable.data}
          svg={<PartnerLogo id={data.airtable.recordId} />}
          id={pageContext.airtable_id}
        />

        {Flags.features.testimonial === true && data.airtable.data.testimonial_id.length > 0 ? (
          <ProfileYoutube
            icon={<Play />}
            title={
              data.airtable.data.name === "Plug and Play"
                ? "Welcoming Words"
                : "Corporate Testimonial"
            }
            videoId={data.airtable.data.testimonial_id}
            speakers={Flags.features.testimonial_profile ? data.airtable.data.testimonial_speaker : null}
            company={data.airtable.data.name}
            css={[css`
              margin-bottom: 0;
              padding-bottom: 5em;
            `]}
          />
        ) : (
          ""
        )}

        <section
          css={css`
            background: ${color.main_light};
            padding-bottom: 5em;
          `}
        >

          {Flags.features.casestudy === true && publishFilter(data.airtable.data.casestudies, "cs_publish") && publishFilter(data.airtable.data.casestudies, "cs_publish").length > 0 ? (
            <div css={wrapper}>
              <TitleHeader
                inline
                title={`Project Teaser`}
                icon={<FileText />}
                css={css`
                  padding-top: 0;
                  padding-bottom: 1em;
                `}
              />
              <PartnerCaseStudies data={data} />
            </div>
          ) : ''}

          {(Flags.features.people === true || Flags.features.people === "profile_only") && champions.length !== 0 && champions !== undefined ? (
            <div css={css`
              margin-bottom: 3em;
            `}>
              <TitleHeader
                title={
                  data.airtable.data.name === "Plug and Play"
                    ? `EXPO Management by ` + data.airtable.data.name
                    : `Champions of ` + data.airtable.data.name
                }
                icon={<Star />}
                css={css`
                  padding-top: 0;
                  padding-bottom: 1em;
                `}
              />
              <ProfileUsers
                data={champions}
                css={css`
                  padding-top: 0;
                  padding-bottom: 0;
                `}
              />
            </div>
          ) : (
            ""
          )}

          {Flags.features.people === true && executives.length !== 0 && executives !== undefined ? (
            <div css={css`
              margin-bottom: 3em;
            `}>
              <TitleHeader
                title={`Executives of ` + data.airtable.data.name}
                icon={<Award />}
                css={css`
                  padding-top: 0;
                  padding-bottom: 1em;
                `}
              />
              <ProfileUsers
                data={executives}
                css={css`
                  padding-top: 0;
                  padding-bottom: 0;
                `}
              />
            </div>
          ) : (
            ""
          )}

          {Flags.features.people === true && attendee.length !== 0 && attendee !== undefined ? (
            <div css={css`
              margin-bottom: 5em;
            `}>
              <TitleHeader
                title={`All Attendees of ` + data.airtable.data.name}
                icon={<People />}
                subtitle={`<p>To take a look at all attendees of ${data.airtable.data.name} please check out the following link which redirects you to the companies dedicated list of participating employees.`}
                transparent
                css={css`
                  padding-top: 0;
                  padding-bottom: 1em;
                `}
              />
              <div css={wrapper}>
                <ArrowLink
                  text={data.airtable.data.name + ` attendee summary`}
                  url={`/people/` + safe_url}
                  css={css`
                    color: ${color.main_dark};
                    margin-top: 0;
                    margin-bottom: 2em;
                    svg {
                      stroke: ${color.main_dark};
                    }
                  `}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {Flags.features.rearview && publishFilter(data.airtable.data.rearview, "publish") &&
          publishFilter(data.airtable.data.rearview, "publish").length > 0 ? (
            <div css={[wrapper, css`
              margin-bottom: 3em;
            `]}>
              <TitleHeader
                title={`Rearview clips by ` + data.airtable.data.name}
                inline
                icon={{
                  svg: <Rearview />,
                  style: "fill"
                }}
                css={css`
                  padding-top: 0;
                  padding-bottom: 1em;
                `}
              />
              <RearviewInline data={publishFilter(data.airtable.data.rearview, "publish")} />
            </div>
          ) : (
            ""
          )}

          {Flags.features.agenda === true && publishFilter(data.airtable.data.agenda, "agenda_publish") && publishFilter(data.airtable.data.agenda, "agenda_publish").length > 0 ? (
            <div css={[wrapper, css`
              margin-bottom: 5em;
            `]}>
              <TitleHeader
                title={`Session with (and by) ` + data.airtable.data.name}
                subtitle={`<p>A sneak peak of the agenda. Find out more on <a href='${agendaDestination}'>the comprehensive overview</a>. </p>`}
                inline
                transparent
                icon={<Calendar />}
                css={css`
                  padding-top: 0;
                `}
              />
              <div>
                {sortAgenda(data.airtable.data.agenda).map((group, index) => (
                  <React.Fragment key={index}>
                    <div
                      css={css`
                        margin: 3em 0 1em;
                        position: relative;
                        line-height: 1em;
                        &:first-of-type {
                          margin-top: 1em;
                        }
                        &:before {
                          content: "";
                          position: absolute;
                          top: 50%;
                          left: 0;
                          background: ${color.main_dark};
                          height: 1px;
                          width: 100%;
                        }
                      `}
                    >
                      <p
                        css={css`
                          font-weight: 700;
                          font-size: 0.85em;
                          margin: 0;
                          display: inline;
                          background: ${color.main_light};
                          position: relative;
                          line-height: 1em;
                          padding-right: 1em;
                        `}
                      >
                        {moment(group.date).format("MMMM Do, YYYY – dddd")}
                      </p>
                    </div>
                    {group.data.map((el, index) => (
                      <AgendaEl
                        key={index}
                        recordId={el.recordId}
                        title={el.data.agenda_title}
                        date={el.data.agenda_start_time}
                        start={moment(el.data.agenda_start_time).format("HH:mm")}
                        start_utc={moment(el.data.agenda_start_time)
                          .utc()
                          .format("h:mm A")}
                        duration={new Date(el.data.agenda_duration * 1000)
                          .toISOString()
                          .substr(12, 4)}
                        tags={el.data.agenda_tags}
                        speakers={el.data.agenda_speaker}
                        hosts={el.data.agenda_host}
                        teaser={el.data.agenda_teaser}
                        description={
                          el.data.agenda_description
                            ? el.data.agenda_description.childMarkdownRemark.excerpt
                            : ""
                        }
                        partners={el.data.agenda_partners}
                        startups={el.data.agenda_startups}
                        password_protected={el.data.password_protected}
                        css={css`
                          :not(:last-of-type) {
                            margin-bottom: 1em;
                          }
                        `}
                      />
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ) : ''}

        </section>
        <GeneralFooter theme={color.main_light} />
      </Layout>
    )
}


export const query = graphql`query Partner($airtable_id: String) {
  airtable(id: {eq: $airtable_id}) {
    recordId
    data {
      name
      url
      program
      active
      type
      hq_country
      start_date(formatString: "MMMM DD, YYYY")
      twitter
      linkedin
      instagram
      description {
        childMarkdownRemark {
          html
        }
      }
      users {
        id
        recordId
        data {
          name
          group
          include
          consent
          surename
          profession
          image {
            localFiles {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG, layout: FULL_WIDTH)
              }
            }
          }
        }
      }
      agenda {
        recordId
        data {
          agenda_description {
            childMarkdownRemark {
              html
              excerpt(format: HTML, truncate: true, pruneLength: 512)
            }
          }
          password_protected
          agenda_start_time
          agenda_publish
          agenda_tags
          agenda_title
          agenda_duration
          agenda_teaser
          agenda_partners {
            recordId
            data {
              name
            }
          }
          agenda_startups {
            recordId
            data {
              startup
            }
          }
        }
      }
      rearview {
        recordId
        data {
          publish
          password_protected
          sort
          rearview_tags
          rearview_thumbnail {
            localFiles {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG, layout: FULL_WIDTH)
              }
            }
          }
          rearview_description {
            childMarkdownRemark {
              excerpt(format: PLAIN, pruneLength: 240)
            }
          }
          rearview_release
          rearview_title
          rearview_partners {
            data {
              name
            }
          }
          rearview_startups {
            data {
              startup
            }
          }
          rearview_agenda {
            data {
              agenda_start_time
            }
          }
        }
      }
      testimonial_id
      testimonial_speaker {
        id
        data {
          name
          profession
        }
      }
      casestudies {
        data {
          cs_title
          cs_publish
          cs_teaser {
            childMarkdownRemark {
              html
            }
          }
          cs_startup {
            recordId
            data {
              startup
              vertical
              country
              city
            }
          }
          cs_agenda {
            recordId
            data {
              agenda_start_time
              agenda_title
              agenda_publish
              password_protected
            }
          }
        }
      }
      pressrelease {
        localFiles {
          publicURL
          extension
          name
        }
      }
    }
  }
}
`

export default PartnerTemplate;